export const getShiftLetter = (shiftCode) => {
    if (!shiftCode) return ''
    return String(shiftCode).charAt(0)
}

export const getShiftBadgeModifier = (name) => {
    switch (name) {
        case 'A':
            return 'primary'
        case 'B':
            return 'success'
        case 'C':
            return 'warning'
        case 'D':
            return 'danger'
        default:
            return 'default'
    }
}

export const getShiftBadgeClassByName = (name) => `badge_${getShiftBadgeModifier(getShiftLetter(name))}`

export const getShiftBadgeClassByIndex = (index) => {
    switch (index) {
        case 0:
            return 'badge_primary'
        case 1:
            return 'badge_success'
        case 2:
            return 'badge_warning'
        case 3:
            return 'badge_danger'
        default:
            return ''
    }
}

export const formatShiftFrameLabel = (shiftDef, { frameLabel = '枠' } = {}) => {
    if (!shiftDef?.name) return ''
    return `${shiftDef.name}${frameLabel}`
}

export const formatShiftSlotLabel = (shiftDef, { lang = 'ja', frameLabel = '枠' } = {}) => {
    if (!shiftDef?.name) return ''
    const { name, startTime, endTime } = shiftDef
    if (lang === 'en') {
        return `${name} ${startTime} - ${endTime}`
    }
    return `${name}${frameLabel} ${startTime}〜${endTime}`
}

/** 月表示グリッド用の短縮ラベル（例: A枠 17〜19） */
export const formatShiftSlotLabelCompact = (shiftDef, { lang = 'ja', frameLabel = '枠' } = {}) => {
    if (!shiftDef?.name) return ''
    const { name, startTime, endTime } = shiftDef
    const compact = (time) => (time ? time.replace(/:00$/, '') : '')
    const start = compact(startTime)
    const end = compact(endTime)
    if (lang === 'en') {
        return `${name} ${start}-${end}`
    }
    return `${name}${frameLabel} ${start}〜${end}`
}

export const resolveShiftSlotLabel = (
    shiftCode,
    shiftDefs,
    { lang = 'ja', frameLabel = '枠' } = {}
) => {
    const letter = getShiftLetter(shiftCode)
    const def = shiftDefs?.find((s) => s.name === letter)
    if (def) {
        return formatShiftSlotLabel(def, { lang, frameLabel })
    }
    return letter
}

export const resolveShiftDefByCode = (shiftCode, shiftDefs) => {
    const letter = getShiftLetter(shiftCode)
    return shiftDefs?.find((s) => s.name === letter)
}
